import { ItemDetail } from "@shared/types";
import { PlayerService } from "./PlayerService";

/**
 * Service responsible for retrieving inventory-related data for the player.
 */
export class InventoryService {
    private _playerService: PlayerService = new PlayerService();

    /**
     * Retrieves detailed information about a specific item in the player's inventory.
     *
     * @param name - The name of the item to fetch details for.
     * @returns A Promise that resolves to an array of `ItemDetail` objects, or `undefined` if the request fails.
     *
     */
    public async itemDetails(name: string): Promise<ItemDetail[] | undefined> {
        const response: Response = await fetch(`${VITE_API_URL}game/inventory`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
            body: JSON.stringify({ item: name }),
        });
        return response.json() as Promise<ItemDetail[]>;
    }
}
